import * as React from 'react';
import {TableSortDirection} from '../../types/Table';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {stylesheet} from 'typestyle';
import {GreenColor, GreyColor, WhiteColor} from '../../styles/colors';

interface SortIconProps {
    sortActive: boolean;
    sortByScoreAttributeActive?: boolean;
    sortDirection: TableSortDirection;
}

export default class SortIcon extends React.Component<SortIconProps> {
    public render() {
        const {sortActive, sortDirection, sortByScoreAttributeActive} = this.props;
        const selectedTransform = sortDirection === TableSortDirection.ASC ? 'flip-v' : '';
        return (
            <span className="fa-layers fa-lg fa-fw">
                {sortActive ? <FontAwesomeIcon icon="square" color={GreenColor} /> : null}
                <FontAwesomeIcon
                    className={sortActive ? iconCss.iconSelected : iconCss.iconDefault}
                    icon="sort-amount-up"
                    inverse
                    transform={'shrink-6 ' + selectedTransform}
                />
                {sortByScoreAttributeActive ? (
                    <span className="fa-layers-counter" style={{background: 'Tomato'}}>
                        +
                    </span>
                ) : null}
            </span>
        );
    }
}

const iconCss = stylesheet({
    iconDefault: {
        color: GreyColor,
    },
    iconSelected: {
        color: WhiteColor,
    },
});



// WEBPACK FOOTER //
// ./src/views/Table/SortIcon.tsx